import { createContext, useContext } from "react"

const AppContext = createContext<AppContextType>({})

export interface AppContextType {
  nonce?: string
}
export interface AppProviderProps {
  children: React.ReactNode
  nonce?: string
}
export const AppProvider = (props: AppProviderProps) => {
  const { children, nonce } = props
  return <AppContext.Provider value={{ nonce }}>{children}</AppContext.Provider>
}

export const useAppContext = () => {
  const context = useContext(AppContext)
  if (!context) {
    throw new Error("useAppContext must be used within an AppProvider")
  }
  return context
}
